<script>
    import Icon from 'svelte-awesome';
    import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';
    import {Card} from '../components/ui';
    import SortableListCardEdit from './SortableListCard_Edit.svelte';
    export let model;

    const addNew = function(){
       let newItem = {
            name: `My ${model.length + 1}. Feature`, 
            value: model.length,
            sortPos: model.length, 
            editMode: true, 
            image: null,
            description: `Describe the main characteristics of your product in order of importance.`,
            items:[
                {text: null, sortPos: 0, value: 0},
                {text: null, sortPos: 1, value: 1},
                {text: null, sortPos: 2, value: 2},
                {text: null, sortPos: 3, value: 3},
                {text: null, sortPos: 4, value: 4}
            ]
        }
	    model = [...model, newItem];
    }
</script>

<div class="overflow-auto">
    {#each model as featureGroup, i}
    <div class="w-1/3 float-left">
        <SortableListCardEdit bind:model={featureGroup} hasFileSelect={true} class="p-4" hasEditMode={true}/>
    </div>
    {/each}
    <div class="w-1/3 float-left opacity-50 hover:opacity-100 cursor-pointer" style="height:410px">
        <Card class="p-4 h-full text-center">
            <button type="button" on:click={addNew} style="margin-top:157px">
                <Icon data={faPlusCircle} scale="3" />
            </button>
        </Card>    
    </div>
</div>